import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import axios from 'axios';
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';




export const Login = (props) => {
    let [loaddata, setloaddata] = useState(null)
    const [messageLogin, setmessageLogin] = useState('Introduce tu código para iniciar sesión');

    const [userPass, setUserPass] = useState(null);

    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }
   
    const passChange = (val) => {
        setUserPass(val.target.value)
    }
    console.log('login')
   
    async function fetchData() {
    
        var url_string = window.location.href
        var url = new URL(url_string);
        var c = url.searchParams.get("code")
        console.log('code',c)
        if (c == null){c = userPass}

        let md5pass = c

        if(md5pass !== null ){
            if(md5pass.length  == 15){
                var addon="";
                for(var block=0;block<3; block++)
                {
                    var loop=0;
                    for(var position=0;position<5;position++){
                        var current=md5pass.charAt(block*5+position);
                        if(current>="A" && current<="Z")
                            loop+=1<<position;
                    }
                    addon+="ABCDEFGHIJKLMNOPQRSTUVWXYZ012345".charAt(loop);
                }
                md5pass=(md5pass+addon);
            }
        }


        if(c !== null ){

          
                var dataForm = {
                    claveUsuario: md5pass,
                };
                
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(dataForm),
                    headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                    },  
                }
                axios.post(`${process.env.REACT_APP_URL_API}auth/loginSF/`, dataForm, requestOptions)
                .then((res) => {
                    setloaddata(true);
                    console.log('login',res)
                    localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-idu`, res.data.data.idUsuario) 
                    localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`, res.data.data.nombre) 
                    localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-token`, res.data.data.token) 
                    localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-id`, res.data.data.claveUsuario)
                    localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-email`, res.data.data.email)
                    localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`) != null && props.activateAuth()
                    props.logEvento(process.env.REACT_APP_EVENTO_ID,false,'Login','true')
                    
                })
                .catch((err) => {
                    console.log('err::',err)
                    setloaddata(false)
                }) 
                

                

                

                /*axios.get(
                    `${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`,
                ).then(res => {
                    //console.log('REST SETINGS',res.data[0].streaming)

                    let bajodemanda = false
                    res.data[0].streaming ? bajodemanda = false : bajodemanda = true
                    var dataFormlog = {  
                        "idUsuario": sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`),
                        "idEvento": process.env.REACT_APP_EVENTO_ID,
                        "ip": "192.168.1.1",
                        "BajoDemanda": bajodemanda,
                        "Navegador": `${window.navigator.userAgent}`
                    }
                    //console.log('LOG',dataFormlog)

                    const urllog = `https://eventosonline.spinmedia.es/api/eventos/GrabarEventoLog`
                    const requestOptionslog = {
                    method: 'POST',
                    body: JSON.stringify(dataFormlog),
                    headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':`Bearer ${sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`)}`
                    },  
                }
                let respuestalog =  fetch(urllog, requestOptionslog)
                })*/
   

        }
        
    }
       
    
   
    useEffect(() => {
        fetchData()
    },[])

   
    return(
        <Fragment>
            <Cabecera imagen={false} top={false} removeAuth={props.removeAuth} />
            <div className='container login' >
                <div className='formContainer'>
                <div className='cols'>
                    <div className='LoginNotice'>{messageLogin}</div>
                </div>
                    <div className='row'>
                        
                        <form onSubmit={(e) => {fetchData(); e.preventDefault();}}>
                            <input className="input-form" type="text" id="passLogin" name="passLogin" placeholder="Código" onChange={passChange} />
                            <div className='col'>
                                <button className="btn btn-gris" type="button" onClick={fetchData}>Iniciar sesión</button>
                                
                            </div>
                        </form>
                        
                    </div>
                </div>
            
            </div>
            <Footer />
        </Fragment>
    )

}